module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/map-marker-f9b124098fd84960d0802b823ce19095.svg";